import * as React from "react";
import { useLazyLoadImage } from "@/Utilities";
import { SvgImagePattern, SvgShadowFilter } from "./SvgTemplateDefs";

function BillboardTemplateSVG({ src, id, ...props }) {

  const uniqueId = 'bd_' + id;
  const imageRef = useLazyLoadImage(src);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return (
    <svg
      width="100%"
      height={360}
      viewBox="0 26 466 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g filter={`url(#filter0_d_${uniqueId})`}>
        <rect
          x={30.9769}
          y={59.2279}
          width={404.046}
          height={307.614}
          rx={3.61832}
          fill="white"
        />
        <path
          d="M41.8319 70.3844H46.6563"
          stroke="#1D1D1D"
          strokeWidth={0.603054}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.8319 72.4951H46.6563"
          stroke="#1D1D1D"
          strokeWidth={0.603054}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.8319 74.6058H46.6563"
          stroke="#1D1D1D"
          strokeWidth={0.603054}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.3755 74.1536L61.7324 75.5104"
          stroke="#1D1D1D"
          strokeWidth={0.603054}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M61.1294 72.1936C61.1294 70.6948 59.9144 69.4799 58.4156 69.4799C56.9169 69.4799 55.7019 70.6948 55.7019 72.1936C55.7019 73.6924 56.9169 74.9073 58.4156 74.9073C59.9144 74.9073 61.1294 73.6924 61.1294 72.1936Z"
          stroke="#1D1D1D"
          strokeWidth={0.603054}
          strokeLinejoin="round"
        />
        <path
          d="M224.986 75.449V69.4526H225.928V74.5923H227.479V75.449H224.986Z"
          fill="#1D1D1D"
        />
        <path
          d="M223.586 69.4526L224.546 75.449H223.595L223.432 74.3611H222.276L222.113 75.449H221.248L222.207 69.4526H223.586ZM222.849 70.5148L222.395 73.5473H223.303L222.849 70.5148Z"
          fill="#1D1D1D"
        />
        <path
          d="M220.032 73.2135H220.923V74.0101C220.923 74.9696 220.444 75.5178 219.519 75.5178C218.593 75.5178 218.114 74.9696 218.114 74.0101V70.892C218.114 69.9326 218.593 69.3844 219.519 69.3844C220.444 69.3844 220.923 69.9326 220.923 70.892V71.4745H220.032V70.8321C220.032 70.4038 219.844 70.241 219.544 70.241C219.244 70.241 219.056 70.4038 219.056 70.8321V74.0701C219.056 74.4984 219.244 74.6526 219.544 74.6526C219.844 74.6526 220.032 74.4984 220.032 74.0701V73.2135Z"
          fill="#1D1D1D"
        />
        <path
          d="M215.657 70.8321V74.0701C215.657 74.4984 215.845 74.6612 216.145 74.6612C216.445 74.6612 216.634 74.4984 216.634 74.0701V70.8321C216.634 70.4038 216.445 70.241 216.145 70.241C215.845 70.241 215.657 70.4038 215.657 70.8321ZM214.715 74.0101V70.892C214.715 69.9326 215.22 69.3844 216.145 69.3844C217.07 69.3844 217.576 69.9326 217.576 70.892V74.0101C217.576 74.9696 217.07 75.5178 216.145 75.5178C215.22 75.5178 214.715 74.9696 214.715 74.0101Z"
          fill="#1D1D1D"
        />
        <path
          d="M211.893 75.449V69.4526H212.835V74.5923H214.386V75.449H211.893Z"
          fill="#1D1D1D"
        />
        <path
          d="M249.431 71.5946C249.431 71.0267 249.71 70.7021 250.253 70.7021C250.795 70.7021 251.074 71.0267 251.074 71.5946V71.7061H250.547V71.5591C250.547 71.3055 250.445 71.2092 250.268 71.2092C250.09 71.2092 249.989 71.3055 249.989 71.5591C249.989 72.2892 251.079 72.4262 251.079 73.4403C251.079 74.0082 250.795 74.3327 250.247 74.3327C249.7 74.3327 249.416 74.0082 249.416 73.4403V73.2222H249.943V73.4758C249.943 73.7293 250.055 73.8206 250.232 73.8206C250.41 73.8206 250.521 73.7293 250.521 73.4758C250.521 72.7456 249.431 72.6087 249.431 71.5946Z"
          fill="#1D1D1D"
        />
        <path
          d="M244.593 74.2514L244.39 72.3601L244.188 74.2514H243.422L243.026 70.702H243.569L243.868 73.501L244.137 70.702H244.674L244.953 73.5213L245.242 70.702H245.729L245.333 74.2514H244.593Z"
          fill="#1D1D1D"
        />
        <path
          d="M238.107 71.2092V72.198H238.872V72.705H238.107V73.7445H239.07V74.2516H237.549V70.7021H239.07V71.2092H238.107Z"
          fill="#1D1D1D"
        />
        <path
          d="M232.763 74.2516L232.069 71.6808V74.2516H231.567V70.7021H232.266L232.839 72.8267V70.7021H233.336V74.2516H232.763Z"
          fill="#1D1D1D"
        />
        <path
          d="M250.869 68.8768H248.033H246.935H241.895H240.797H235.762H234.659H231.828C230.007 68.8768 228.526 70.3586 228.526 72.1796V72.8108C228.526 74.6317 230.007 76.1135 231.828 76.1135H234.659H235.762H240.797H241.895H246.935H248.034H250.869C252.69 76.1135 254.172 74.6317 254.172 72.8108V72.1796C254.171 70.3584 252.69 68.8768 250.869 68.8768ZM234.659 75.0101H231.828C230.615 75.0101 229.629 74.0235 229.629 72.8106V72.1794C229.629 70.9664 230.615 69.9798 231.828 69.9798H234.659V75.0101ZM240.792 75.0101H235.762V69.98H240.792V75.0101ZM246.93 75.0101H241.9V69.98H246.93V75.0101ZM253.068 72.8106C253.068 74.0235 252.081 75.0101 250.869 75.0101H248.038V69.98H250.869C252.081 69.98 253.068 70.9666 253.068 72.1796V72.8106Z"
          fill="#1D1D1D"
        />
        <path
          d="M420.121 73.545C419.694 73.799 418.576 74.3177 419.257 74.9667C419.59 75.2837 419.96 75.5105 420.426 75.5105H423.085C423.551 75.5105 423.922 75.2837 424.255 74.9667C424.936 74.3177 423.817 73.799 423.391 73.545C422.39 72.9493 421.121 72.9493 420.121 73.545Z"
          stroke="#1D1D1D"
          strokeWidth={0.603054}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M423.113 70.8367C423.113 71.5861 422.505 72.1936 421.756 72.1936C421.006 72.1936 420.399 71.5861 420.399 70.8367C420.399 70.0874 421.006 69.4799 421.756 69.4799C422.505 69.4799 423.113 70.0874 423.113 70.8367Z"
          stroke="#1D1D1D"
          strokeWidth={0.603054}
        />
        <g clipPath={`url(#clip0_${uniqueId})`}>
          <rect
            x={52.1598}
            y={124.945}
            width={361.487}
            height={93.4694}
            fill={`url(#pattern0_${uniqueId})`}
          />
        </g>
        <rect
          x={112.389}
          y={233.255}
          width={241.222}
          height={9.04581}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={112.389}
          y={245.92}
          width={241.222}
          height={9.04581}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={112.389}
          y={258.584}
          width={241.222}
          height={9.04581}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={112.389}
          y={271.248}
          width={150.764}
          height={9.04581}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={112.389}
          y={304.973}
          width={77.995}
          height={54.2749}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={194.002}
          y={304.973}
          width={77.995}
          height={54.2749}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={275.616}
          y={304.973}
          width={77.995}
          height={54.2749}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={112.389}
          y={90.6332}
          width={241.222}
          height={9.04581}
          rx={1.20611}
          fill="#F0F0F0"
        />
        <rect
          x={112.389}
          y={103.297}
          width={150.764}
          height={9.04581}
          rx={1.20611}
          fill="#F0F0F0"
        />
      </g>
      <defs>
        <SvgShadowFilter id={"filter0_d_" + uniqueId} uniqueId={uniqueId} x={6.85476} y={38.7241} width={452.291} height={355.858}
          radius={6.03054} dy={3.61832} blur={9.04581} />
        <SvgImagePattern id={"pattern0_" + uniqueId} uniqueId={uniqueId} transform="matrix(0.00109051 0 0 0.00421749 0 -0.0271858)" />
        <clipPath id={"clip0_" + uniqueId}>
          <rect
            x={52.2565}
            y={124.953}
            width={361.487}
            height={93.2}
            rx={2.3675}
            fill="white"
          />
        </clipPath>
        <image
          id={"image0_" + uniqueId}
          ref={imageRef}
          width={917}
          height={250}
          href={isSafari ? src : ''}
          loading="lazy"
        />
      </defs>
    </svg>);
}
export const SvgTemplateBillboard = React.memo(BillboardTemplateSVG);